import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/play-button-overlay.svg'


const _withScopeId = n => (_pushScopeId("data-v-a6affeee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay-content"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Welcome to Onramp Academy", -1))
const _hoisted_3 = {
  key: 1,
  class: "overlay-content"
}
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: "overlay-container pb-5",
    height: '400px',
    "background-color": _ctx.background
  }, {
    default: _withCtx(() => [
      (_ctx.showOverlay)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: _imports_0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args)))
            }),
            _hoisted_2
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("iframe", {
              src: _ctx.autoplaySource,
              frameborder: "0",
              webkitAllowFullScreen: "",
              mozallowfullscreen: "",
              allowFullScreen: "",
              allow: "autoplay"
            }, null, 8, _hoisted_4)
          ]))
    ]),
    _: 1
  }, 8, ["background-color"]))
}